<div class="print-only mb-5">
  <img class="logo pull-left" [src]="branding.logoUrl" />
  <span class="title">{{ branding.title }}</span>
  <span class="subtitle">{{ branding.subTitle }}</span>
</div>
<nav>
  <ul class="breadcrumb">
    <li><a routerLink="/sample-search"><i class="fa fa-search" style="width: 20px;"></i>Sample Search</a></li>
    <li class="ms-auto"><a href="#" (click)="print($event)"><i class="fa fa-print" style="width: 20px;"></i>Print</a></li>
    <li class="ms-3">@if (externalLinks) {
      <a [href]="externalLinks.dataBankResourcesUrl" target="_blank"><i class="fa fa-external-link" style="width: 20px;"></i>DNA Data Bank Resources</a>
    }</li>
  </ul>
</nav>
<div class="text-center">
  <h1>DNA Sample Pre-Log Details</h1>
</div>
@if (errorMessage) {
  <div class="col-12 col-lg-6 offset-lg-3 alert alert-danger">{{errorMessage}}</div>
}
<app-pre-log-display [preLog]="preLog"></app-pre-log-display>
